import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _796fa41d = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _1b5b1718 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _19ba48de = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _914d28ba = () => interopDefault(import('..\\pages\\need-a-card.vue' /* webpackChunkName: "pages_need-a-card" */))
const _2a5d1774 = () => interopDefault(import('..\\pages\\patient-information.vue' /* webpackChunkName: "pages_patient-information" */))
const _7fc226ce = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _2cfb5cda = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _68709bb9 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _687eb33a = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _689ae23c = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _68a8f9bd = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _c552520c = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _50d60e3c = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/eligibility",
    component: _796fa41d,
    name: "eligibility"
  }, {
    path: "/error",
    component: _1b5b1718,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _19ba48de,
    name: "have-a-card"
  }, {
    path: "/need-a-card",
    component: _914d28ba,
    name: "need-a-card"
  }, {
    path: "/patient-information",
    component: _2a5d1774,
    name: "patient-information"
  }, {
    path: "/rejection",
    component: _7fc226ce,
    name: "rejection"
  }, {
    path: "/success",
    component: _2cfb5cda,
    name: "success"
  }, {
    path: "/errors/400",
    component: _68709bb9,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _687eb33a,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _689ae23c,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _68a8f9bd,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _c552520c,
    name: "errors-500"
  }, {
    path: "/",
    component: _50d60e3c,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
